const asyncComponentFactory = (handle) => {
  return (node, ctx) => {
    return import(
      /* webpackChunkName: "[request]" */
      /* webpackMode: "lazy" */
      `./components/${handle}`
    ).then((module) => {
      const instance = module.default(node, ctx);
      const unsubscribe = ctx.on('unmount', () => {
        instance.unmount();
        unsubscribe();
      });
    });
  };
};

// UI COMPONENTS ==============================================================
//import MiniCart from './components/ui/cart/MiniCart';
import Search from './components/ui/Search';

// NAV COMPONENTS ==============================================================
import MobileNav from './components/nav/MobileNav';
import MegaMenu from './components/nav/MegaMenu';

export const AppComponents = {
  // NAV COMPONENTS ==============================================================
  MobileNav,
  MegaMenu,

  // Content Components ------------------------------------------------------------
  ElementLoop: asyncComponentFactory('content/ElementLoop'),
  // PRODUCT Components ---------------------------------------------------------
  QuickATC: asyncComponentFactory('product/QuickATC'),
  ProductForm: asyncComponentFactory('product/ProductForm'),
  ProductGallery: asyncComponentFactory('product/ProductGallery'),
  CardProductForm: asyncComponentFactory('product/CardProductForm'),

  // MEDIA Components ------------------------------------------------------------
  MediaPlayer: asyncComponentFactory('media/MediaPlayer'),

  // UI Components ------------------------------------------------------------
  FoldableTile: asyncComponentFactory('ui/FoldableTile'),
  Accordion: asyncComponentFactory('ui/Accordion'),
  Dropdown: asyncComponentFactory('ui/Dropdown/index.js'),
  JumpTo: asyncComponentFactory('ui/JumpTo'),
  CollectionSort: asyncComponentFactory('ui/CollectionSort/index.js'),
  LazyLoader: asyncComponentFactory('ui/LazyLoader'),
  Filter: asyncComponentFactory('ui/Filter'),
  MainCart: asyncComponentFactory('ui/cart/MainCart'),
  //MiniCart,
  Search,
  // Tabs: asyncComponentFactory('ui/Tabs'),
  Modal: asyncComponentFactory('ui/Modal'),
  Slider: asyncComponentFactory('ui/Slider'),
};
